'use client';

import { motion } from 'motion/react';

export default function Partners() {
  const partners = ['ESL', 'UEFA', 'CONMEBOL', 'BLAST', 'PGL', 'FIFA'];

  return (
    <section className="bg-[#0f0f0f] py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 flex items-center justify-center gap-4">
          <div className="h-px w-12 bg-zinc-800" />
          <h2 className="text-sm font-bold tracking-[0.2em] text-zinc-400">STRATEGIC PARTNERS</h2>
          <div className="h-px w-12 bg-zinc-800" />
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {partners.map((partner, index) => (
            <motion.div
              key={partner}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex h-24 items-center justify-center rounded-lg bg-[#0a0a0a] border border-zinc-800/50 transition-colors hover:border-zinc-700"
            >
              <span className="text-sm font-bold tracking-widest text-zinc-500">{partner}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
